import { NAV_MODES } from 'shared/stores/annotations';

export const IA_DRAW_MODES = [
  NAV_MODES.RECT,
  NAV_MODES.ELLIPSE,
  NAV_MODES.PEN
];



// WEBPACK FOOTER //
// ./src/shared/stores/image-analysis/consts.js